/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!***************************************!*\
  !*** ./src/assets/js/cstm-product.js ***!
  \***************************************/
document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.product-info-item__select')) {
    document.querySelectorAll('.product-info-item__select .product-info-item__select-active').forEach(function (item) {
      item.addEventListener('click', function () {
        this.closest('.product-info-item__select').classList.toggle('active');
      });
    });
  }
  if (document.querySelector('[data-fancybox="list__gallery')) {
    Fancybox.bind('[data-fancybox="list__gallery"]');
  }
});
document.addEventListener('DOMContentLoaded', function () {
  var giftCardElement = document.querySelector('.gift-card');
  var giftcardDropdownElement = document.querySelector('.giftcard-dropdown');

  // Function to toggle display of an element
  function toggleDisplay(element, shouldDisplay) {
    element.style.display = shouldDisplay ? 'block' : 'none';
  }

  // Function to handle changes in gift wrapping options
  function handleGiftWrappingChange() {
    var isGiftTrue = document.getElementById('package-true').checked;
    toggleDisplay(giftCardElement, isGiftTrue);

    // If gift is not true, click on 'card-false' and hide dropdown
    if (!isGiftTrue) {
      document.getElementById('card-false').click();
      toggleDisplay(giftcardDropdownElement, false);
    }
  }

  // Function to handle changes in gift card mail options
  function handleGiftCardMailChange() {
    var isCardTrue = document.getElementById('card-true').checked;
    toggleDisplay(giftcardDropdownElement, isCardTrue);
  }

  // Add event listener to gift wrapping options
  document.querySelectorAll('.product-features__package-option input[type="radio"]').forEach(function (input) {
    input.addEventListener('change', handleGiftWrappingChange);
  });

  // Add event listener to gift card mail options
  document.querySelectorAll('.gift-card__yes-no-option input[type="radio"]').forEach(function (input) {
    input.addEventListener('change', handleGiftCardMailChange);
  });

  // Initial check in case of pre-selected options
  handleGiftWrappingChange();
  handleGiftCardMailChange();
  document.querySelectorAll('.product-form__submit').forEach(function (item) {
    item.addEventListener('click', function () {
      setTimeout(function () {
        console.log(item.closest('product-info').querySelector('input#package-true').checked, 'click');
        if (item.closest('product-info').querySelector('input#package-true').checked) {
          item.closest('product-info').querySelector('.order-wrapping-cta').click();
        }
      }, 500);
    });
  });
});
/******/ })()
;